import React, { useEffect, useState } from 'react';
import imagearrow from '../../assets/images/dubailogodropdown/Tab01.png';
import imagearroworange from '../../assets/images/dubailogodropdown/Tab01_hvr.png';
import { IoMdArrowDropdown } from "react-icons/io";
import Faq from '../../components/Faq/Faq';
import Ourleaders from '../../components/Ourleaders/Ourleaders';
import Metatag from '../../components/Metatag/Metatag';

const Mpezservice = () => {
    useEffect(() => {
        // Scroll to the top when the page loads
        window.scrollTo(0, 0);
      }, []);
      
  const accordionItems = [
    {
        title: 'How can your HVAC services improve energy efficiency?',
        content: (
            <p>
                Our HVAC services are designed to enhance energy efficiency in both residential and commercial properties. By conducting comprehensive assessments of existing systems, we identify opportunities for optimization and recommend energy-efficient solutions. Our services include the installation of advanced heating and cooling systems, regular maintenance, and system upgrades that incorporate smart technology for precise climate control. These improvements not only reduce energy consumption and costs but also enhance indoor comfort and air quality. Investing in energy-efficient HVAC solutions contributes to a sustainable environment and a healthier living or working space.
            </p>
        ),
    },
    {
        title: 'What benefits do solar systems provide for residential and commercial properties?',
        content: (
            <p>
                Solar systems offer numerous benefits, including significant savings on energy bills, reduced carbon footprint, and increased property value. By harnessing the power of the sun, solar energy systems provide a reliable and sustainable source of electricity. Our team specializes in designing and installing custom solar solutions that meet the unique energy needs of both residential and commercial clients. We also assist with navigating incentives and rebates available for solar installations, making it easier to transition to renewable energy. By investing in solar, you can achieve long-term savings while contributing to a greener future.
            </p>
        ),
    },
    {
        title: 'How does your plumbing service ensure compliance with local codes?',
        content: (
            <p>
                Our plumbing services are committed to adhering to all local codes and regulations to ensure safety and reliability. Our experienced plumbers are well-versed in the latest plumbing standards and practices. We conduct thorough inspections and assessments of your plumbing systems, ensuring all installations and repairs meet regulatory requirements. Our focus on compliance not only prevents potential legal issues but also enhances the efficiency and longevity of your plumbing systems. By choosing our plumbing services, you can have peace of mind knowing your systems are up to code and functioning optimally.
            </p>
        ),
    },
    {
        title: 'What electrical services do you offer for residential and commercial properties?',
        content: (
            <p>
                We offer a comprehensive range of electrical services tailored to meet the needs of both residential and commercial clients. Our services include electrical installations, repairs, upgrades, and inspections. Whether you need to install new lighting fixtures, upgrade your electrical panel, or perform safety inspections, our licensed electricians are equipped to handle it all. We prioritize safety and compliance with all electrical codes, ensuring your systems operate reliably and efficiently. Our goal is to provide quality electrical solutions that enhance your property’s functionality and safety.
            </p>
        ),
    },
    {
        title: 'How can data cabling services enhance my business operations?',
        content: (
            <p>
                Data cabling services are crucial for ensuring reliable and efficient communication within your business. Our team specializes in the design and installation of structured cabling systems that support data transmission for various applications, including voice, video, and internet connectivity. By investing in high-quality data cabling, businesses can achieve faster network speeds, improved reliability, and scalability for future growth. We assess your unique business needs to create tailored cabling solutions that enhance your operational efficiency and support seamless communication across your organization.
            </p>
        ),
    },
];
      const datas = [
        {
            img1: imagearrow,
            img2: imagearroworange,
            mainheading: "ELECTRICAL",
            heading: "Comprehensive Electrical Solutions",
            list1: "Safe and Reliable Installations",
            list2: "Energy-Efficient Upgrades",
            list3: "Troubleshooting and Repairs",
            list4: "Preventive Maintenance Services",
            text: "We provide a full range of electrical services, including installations, upgrades, and repairs. Our experienced electricians ensure that all work is performed safely and efficiently, meeting all local codes and regulations.",
            subheading: "Why Trust Our Electrical Services?",
            subheadingtext1: "Our skilled electricians are trained to handle all types of electrical installations, from residential to commercial projects. We ensure that your systems are installed correctly, providing reliable and safe operation.",
            subheadingtext2: "Energy efficiency is key in today’s world. We offer upgrades to existing systems, helping you save on energy costs while enhancing performance and reliability.",
            subheadingtext3: "Electrical issues can be complex and dangerous. Our team is trained to troubleshoot and resolve any problems quickly, ensuring your safety and minimizing downtime.",
            subheadingtext4: "Preventive maintenance is crucial for electrical systems. We provide comprehensive maintenance services to keep your systems in top shape, preventing issues before they arise and ensuring reliable performance.",
        },
         {
            img1: imagearrow,
            img2: imagearroworange,
            mainheading: "PLUMBING",
            heading: "Our Services Include",
            list1: "Licensed and Experienced Plumbers",
            list2: "Fast and Efficient Repairs",
            list3: "Customer Satisfaction Guaranteed",
            list4: "24/7 Emergency Service",
            text: "Whether it’s a leaky faucet, clogged drain, or a major pipe repair, our team of certified plumbers is here to help. We provide a comprehensive range of plumbing services for residential and commercial properties. From routine maintenance to emergency repairs, we’ve got you covered.",
            subheading: "Why Choose Us for Plumbing Services?",
            subheadingtext1: "Our team of licensed and experienced plumbers is dedicated to providing high-quality services. We are equipped to handle any plumbing issue, big or small, ensuring your plumbing systems run smoothly.",
            subheadingtext2: "We pride ourselves on our fast and efficient repair services. Our goal is to minimize disruptions to your home or business, providing prompt solutions that restore functionality quickly.",
            subheadingtext3: "Customer satisfaction is our top priority. We take the time to listen to your concerns and provide tailored solutions that meet your specific needs, ensuring you receive the best service possible.",
            subheadingtext4: "We understand that plumbing emergencies can happen at any time. That's why we offer 24/7 emergency service, ready to respond to your needs whenever they arise, providing peace of mind for our clients.",
        },
        {
            img1: imagearrow,
            img2: imagearroworange,
            mainheading: "HVAC",
            heading: "Optimal Heating and Cooling Solutions",
            list1: "Energy-Efficient Systems",
            list2: "Customizable HVAC Solutions",
            list3: "Regular Maintenance Services",
            list4: "Expert Installation and Support",
            text: "At Megavolt Contracting LLC, we specialize in providing top-notch HVAC solutions tailored to your specific needs. Our team of highly skilled professionals works with advanced technology to ensure that your indoor climate is comfortable and energy-efficient. From installation to maintenance, we are committed to delivering services that enhance the performance of your HVAC systems.",
            subheading: "Why Choose Our HVAC Services?",
            subheadingtext1: "Our HVAC systems are designed to maximize energy efficiency while providing superior comfort. We offer customized solutions that fit your unique space and requirements. Our expert team evaluates your needs and recommends the best options to optimize your indoor environment.",
            subheadingtext2: "We understand the importance of regular maintenance to prolong the life of your HVAC system. Our scheduled maintenance services ensure that your systems operate smoothly and efficiently, reducing the risk of costly repairs down the line.",
            subheadingtext3: "With years of experience in the industry, our skilled technicians provide expert installation services, ensuring that every component of your HVAC system is set up correctly for optimal performance.",
            subheadingtext4: "We are dedicated to providing excellent customer service. Our team is always available to address your concerns and ensure your satisfaction, making your HVAC experience seamless and hassle-free.",
        },
       
       
      
        {
            img1: imagearrow,
            img2: imagearroworange,
            mainheading: "DATA CABLING",
            heading: "Efficient Data Solutions",
            list1: "Structured Cabling Systems",
            list2: "Reliable Network Solutions",
            list3: "Installation and Testing",
            list4: "Ongoing Support and Maintenance",
            text: "Our data cabling services provide the foundation for a reliable and efficient network. We specialize in designing and installing structured cabling systems that meet the needs of businesses of all sizes, ensuring seamless connectivity and performance.",
            subheading: "Why Choose Our Data Cabling Services?",
            subheadingtext1: "We offer structured cabling solutions that optimize your network's performance. Our experienced team designs systems tailored to your specific needs, ensuring efficient data flow and connectivity.",
            subheadingtext2: "Reliability is crucial for any network. We provide installation services that adhere to the highest standards, ensuring your systems function smoothly and effectively.",
            subheadingtext3: "Our team conducts thorough testing of all cabling installations, ensuring that every connection is secure and meets performance standards. We are committed to delivering quality results.",
            subheadingtext4: "Post-installation, we offer ongoing support and maintenance services to ensure your cabling systems remain efficient and reliable. Our team is always available to address any concerns you may have."
        },
        {
            img1: imagearrow,
            img2: imagearroworange,
            mainheading: "SOLAR SYSTEM",
            heading: "Sustainable Energy Solutions",
            list1: "Custom Solar Panel Installations",
            list2: "Efficient Energy Management",
            list3: "Maintenance and Support",
            list4: "Solar Incentive Consultation",
            text: "Our solar systems provide an eco-friendly and cost-effective energy solution for your home or business. We offer comprehensive services that include design, installation, and ongoing maintenance of solar energy systems, helping you harness the power of the sun while reducing your carbon footprint.",
            subheading: "Benefits of Our Solar Systems",
            subheadingtext1: "Switching to solar energy not only reduces your energy bills but also contributes to a sustainable future. Our systems are designed to maximize energy capture and efficiency, ensuring you get the most out of your investment.",
            subheadingtext2: "Our team of experts guides you through the installation process, providing customized solutions based on your energy needs and preferences. We ensure that your solar system is tailored to your specific requirements.",
            subheadingtext3: "Ongoing maintenance is essential for maximizing your solar system’s performance. We offer comprehensive maintenance services that keep your system running smoothly and efficiently throughout its lifespan.",
            subheadingtext4: "Navigating solar incentives and rebates can be complex. Our team is here to help you understand and access available incentives, maximizing your savings and benefits when switching to solar energy.",
        },
    ];
    
    

    // State to track the active item
    const [activeIndex, setActiveIndex] = useState(0); // Show first item by default

    return (
        <>
        <Metatag title="MEPZ Services | Comprehensive Solutions for Export and Manufacturing Businesses" description=" Explore MEPZ services designed to support your
export and manufacturing operations. Benefit from tax exemptions, modern infrastructure, and streamlined processes." link="mpezservice"/>
        <div className='  bg-[#0000000f]'>
        <h1 className="mb-4 text-2xl font-bold uppercase pt-6  text-center md:text-4xl">Our Expertise</h1>
            <p className="mt-4 text-xl text-[#ff8a00] font-semibold text-center">
                We provide more services to increase productivity
            </p>
            <p className="mt-4   text-center container">
            We offer a diverse range of services designed to boost efficiency and streamline operations. Our expert team is committed to delivering top-quality solutions, ensuring the highest standards of service. Whether you need HVAC installations, solar system setups, or comprehensive electrical work, we are here to meet all your needs with professionalism and precision.

            </p>
        </div>
            

            <div className='xl:pt-8 bg-[#0000000f]'>
                <div className=' p-3 grid grid-cols-1 gap-5 xl:grid-cols-2 container'>
                    {/* Left Section: Display headings and update activeIndex on click */}
                    <div className='mt-20'>
                        {datas.map((item, index) => (
                            <p
                                key={index}
                                onClick={() => setActiveIndex(index)} // Set active item on click
                                className={`mb-4 cursor-pointer ${activeIndex === index ? 'font-bold' : ''}`}
                                style={{
                                    backgroundImage: `url(${activeIndex === index ? item.img2 : item.img1})`, // Change background based on active state
                                    backgroundSize: '100% 100%',
                                    padding: '20px 30px 32px'
                                }}
                            >
                                {item.mainheading}
                            </p>
                        ))}
                    </div>

                    {/* Right Section: Display content of the active item */}
                    <div className="flex items-center justify-center">
                    <div class="custom-bg-container flex flex-col justify-center">
                            <p className=' p-4  sm:pt-24'>{datas[activeIndex].text}</p>
                            <h1 className='font-bold  text-xl  tracking-wide pt-5'>{datas[activeIndex].heading}</h1>
                            <ul className='list-disc pt-4 pl-5 pb-5  leading-6  '>
                                <li>{datas[activeIndex].list1}</li>
                                <li>{datas[activeIndex].list2}</li>
                                <li>{datas[activeIndex].list3}</li>
                                <li>{datas[activeIndex].list4}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className='container sm:mt-6 p-3 mb-5'>
                {datas[activeIndex] && (
                    <>
                        <div className='mt-5'>
                            <div className='p-3 container'>
                                <p className='font-bold text-4xl'>Here’s how we work</p>
                                <p className='font-semibold text-xl pt-5'>{datas[activeIndex].subheading}</p>
                            </div>
                        </div>

                        <div className="bg-white p-4 rounded text-center border " style={{ boxShadow: '0px 3px 5px 1px rgb(197 193 193 / 47%)' }}>
                            <p className="">{datas[activeIndex].subheadingtext1}</p>
                        </div>
                        <div className="flex justify-center flex-col items-center">
                            <div className="h-14 w-[2px] border-r-[3px] border border-[#7a797978]"></div>
                            <IoMdArrowDropdown size={46} className="text-[#c0c0c0] mt-[-20px]" />
                        </div>
                        <div className="bg-white p-4 rounded text-center border" style={{ boxShadow: '0px 3px 5px 1px rgb(197 193 193 / 47%)' }}>
                            <p className="">{datas[activeIndex].subheadingtext2}</p>
                        </div>
                        <div className="flex justify-center flex-col items-center">
                            <div className="h-14 w-[2px] border-r-[3px] border border-[#7a797978]"></div>
                            <IoMdArrowDropdown size={46} className="text-[#c0c0c0] mt-[-20px]" />
                        </div>

                        <div className="bg-white p-4 rounded text-center border "style={{ boxShadow: '0px 3px 5px 1px rgb(197 193 193 / 47%)' }}>
                            <p className="">{datas[activeIndex].subheadingtext3}</p>
                        </div>
                        <div className="flex justify-center flex-col items-center">
                            <div className="h-14 w-[2px] border-r-[3px] border border-[#7a797978]"></div>
                            <IoMdArrowDropdown size={46} className="text-[#c0c0c0] mt-[-20px]" />
                        </div>

                       
                        <div className="bg-white p-4 rounded text-center border "style={{ boxShadow: '0px 3px 5px 1px rgb(197 193 193 / 47%)' }}>
                            <p className="">{datas[activeIndex].subheadingtext4}</p>
                        </div>
                    </>
                )}
            </div>
            
     {/* our leaders */}
   {/* <Ourleaders/> */}
            <Faq items={accordionItems}/>
            
        </>
    );
}

export default Mpezservice  ;
